import { ACTION_TYPES, USER_OPR_STATE, SERVER_OPR_STATE } from '../constants';
import { createReducer } from '@reduxjs/toolkit';

function updateLoadState(state, loadState) {
  state[SERVER_OPR_STATE.LOAD] = loadState;
  return state;
}

// eslint-disable-next-line import/no-default-export -- FIXME: Convert to a named export https://github.com/wegotpop/popsss/wiki/Imports#default-exports
export default createReducer({}, (builder) => {
  builder
    .addCase(ACTION_TYPES.LOAD_FAQS_START, (state, action) =>
      updateLoadState(state, SERVER_OPR_STATE.LOADING),
    )
    .addCase(ACTION_TYPES.LOAD_FAQS_SUCCESSFUL, (state, action) =>
      updateLoadState(state, SERVER_OPR_STATE.LOADING_SUCCESSFUL),
    )
    .addCase(ACTION_TYPES.LOAD_FAQS_FAILED, (state, action) =>
      updateLoadState(state, SERVER_OPR_STATE.LOADING_FAILED),
    )
    .addCase(ACTION_TYPES.LOAD_EDIT_PERM, (state, action) => {
      state[USER_OPR_STATE.EDIT_PERM] = action.editPerm;
      return state;
    })
    .addCase(ACTION_TYPES.LOAD_EDIT_GLOBAL_PERM, (state, action) => {
      state[USER_OPR_STATE.EDIT_GLOBAL_PERM] = action.editGlobalPerm;
      return state;
    });
});
